
import Button from '../base/Button';

export default function Header() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/eb8ff83a3546fe57070bf812bafc35d3.jfif"
              alt="ZOLLER"
              className="h-12 w-auto"
            />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('benefits')}
              className="text-gray-700 hover:text-yellow-600 cursor-pointer"
            >
              導入効果
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-yellow-600 cursor-pointer"
            >
              製品比較
            </button>
            <button 
              onClick={() => scrollToSection('cases')}
              className="text-gray-700 hover:text-yellow-600 cursor-pointer"
            >
              導入事例
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-700 hover:text-yellow-600 cursor-pointer"
            >
              よくある質問
            </button>
          </nav>
          
          <Button 
            variant="primary" 
            size="sm"
            onClick={() => scrollToSection('contact')}
          >
            無料診断を申し込む
          </Button>
        </div>
      </div>
    </header>
  );
}
